import api from './api';

/** URLs vigentes de las imágenes de la fundadora (null = usa la de por defecto). */
export interface FounderImages {
  imageAbout: string | null;
  imageCompact: string | null;
}

/**
 * Solo las variantes a reemplazar: una URL ya subida, o el base64 de la imagen
 * nueva (el backend la sube a R2 y guarda la URL resultante).
 */
export interface FounderImagesUpdate {
  imageAbout?: string;
  imageCompact?: string;
}

class SiteContentService {
  /** Imágenes de la fundadora para el sitio público */
  async getFounderImages(): Promise<FounderImages> {
    const response = await api.get('/site-content/founder');
    return response.data.data;
  }

  /** Reemplazar una o ambas imágenes de la fundadora (admin) */
  async updateFounderImages(
    updates: FounderImagesUpdate
  ): Promise<FounderImages> {
    const response = await api.put('/site-content/founder', updates);
    return response.data.data;
  }
}

export default new SiteContentService();
